import { makeGetRequest, makePostRequest } from 'lib/axios';
import type {
  BagelAiFlowMap,
  BagelFlowTestResult,
  BagelAiFlowNodeTestResult,
} from '../config/types/aiFlow';

export async function getBagelAiFlow(): Promise<BagelAiFlowMap> {
  const res = await makeGetRequest<{
    message: string;
    payload: BagelAiFlowMap;
  }>('/bagel/ai-flow');
  return res.data.payload;
}

export async function testBagelAiFlow(text: string): Promise<BagelFlowTestResult> {
  const res = await makePostRequest<{
    message: string;
    payload: BagelFlowTestResult;
  }>('/bagel/ai-flow/test', { text });
  return res.data.payload;
}

export async function testBagelAiFlowNode(
  nodeId: string,
  promptContent: string,
  testInput: string,
): Promise<BagelAiFlowNodeTestResult> {
  const res = await makePostRequest<{
    message: string;
    payload: BagelAiFlowNodeTestResult;
  }>('/bagel/ai-flow/test-node', { nodeId, promptContent, testInput });
  return res.data.payload;
}
